import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useChunkTranslation } from "../hooks";
const SuspenseChunkTranslation = (param)=>{
    let { children, chunkFile, fallback, options } = param;
    const done = useChunkTranslation(chunkFile, options());
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: done ? children : fallback
    });
};
export { SuspenseChunkTranslation };
